import React, {useState} from "react";
import {useSite} from "../../context/SiteContext";
import {GEAR, GEAR_COLORS, PHOTO} from "../../data/siteData";
import {asset, inkOn, stagger} from "../../utils";
import Icon from "../common/Icon";
import ImageSlot from "../common/ImageSlot";
import Wave from "../common/Wave";

const gearColor = (pos) => GEAR_COLORS[pos % GEAR_COLORS.length];

// "What's in the box": an accordion list, each item can play its video in the frame beside it.
const GearSection = () => {
    const {wide, headerH} = useSite();
    const [openIndex, setOpenIndex] = useState(-1);
    const [videoIndex, setVideoIndex] = useState(-1);
    const current = GEAR[videoIndex];

    const playVideo = (i) => {
        setVideoIndex(i);
        if (wide) return;
        // On a phone the frame sits below the list, so bring it into view.
        const el = document.getElementById('pb-gear-frame');
        if (el) {
            window.scrollTo({top: window.scrollY + el.getBoundingClientRect().top - (headerH + 10), behavior: 'smooth'});
        }
    };

    return (
        <section className="pb-gear">
            <Wave fill="#0a1c3c" flip height={88}/>
            <div className="pb-gear-grid">
                <div>
                    <p className="pb-pill" style={{background: 'rgba(255,255,255,0.12)', color: '#ffd84d'}}>
                        <Icon name="box" size={15}/>What's in the box
                    </p>
                    <h2 className="pb-gear-title">Everything you have to own and carry.</h2>
                    <div style={{display: 'flex', flexDirection: 'column', gap: 10}}>
                        {GEAR.map((g, i) => {
                            const open = openIndex === i;
                            const color = gearColor(g.pos);
                            return (
                                <div key={g.name} className="pb-reveal pb-gear-item" style={{
                                    background: open || videoIndex === i ? 'rgba(255,255,255,0.13)' : 'rgba(255,255,255,0.07)',
                                    borderLeftColor: color, animationDelay: stagger(i, 70)
                                }}>
                                    <button onClick={() => setOpenIndex(open ? -1 : i)} aria-expanded={open}
                                            className="pb-gear-toggle">
                                        <span style={{display: 'block', minWidth: 0}}>
                                            <span className="pb-gear-name">{g.name}</span>
                                            {g.note && <span className="pb-gear-note">{g.note}</span>}
                                        </span>
                                        <span className="pb-chevron" style={{color: '#a9bdd8', transform: open ? 'rotate(180deg)' : 'none'}}>
                                            <Icon name="chev" size={18}/>
                                        </span>
                                    </button>
                                    {open && (
                                        <div style={{padding: '0 16px 16px 16px'}}>
                                            <p className="pb-gear-more">{g.more}</p>
                                            <button onClick={() => playVideo(i)} className="pb-gear-play hover-brighten"
                                                    style={{background: color, color: inkOn(color)}}>
                                                <Icon name="play" size={15}/>Watch video
                                            </button>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div id="pb-gear-frame" className="pb-gear-frame">
                    <ImageSlot src={PHOTO.gear} alt="Open box with the gear laid out, shot from above"/>
                    {current && (
                        <div className="pb-gear-video">
                            <video key={'gear-' + videoIndex} src={asset(current.video)} autoPlay controls playsInline
                                   preload="metadata"/>
                            <p className="pb-gear-video-label">
                                <span style={{background: gearColor(current.pos)}}/>{current.name}
                            </p>
                            <button onClick={() => setVideoIndex(-1)} aria-label="Close video"
                                    className="pb-gear-video-close">×
                            </button>
                        </div>
                    )}
                </div>
            </div>
            <Wave fill="#eef4fb" height={92}/>
        </section>
    );
};

export default GearSection;
